import { useQuery } from "@tanstack/react-query";
import getSiteSettingsByKey from "services/getSiteSettingsByKey";

interface PromoResult {
  promoCode: string | null;
  discountPct: number;
  slotsLeft: number | null;
  discountedPrice: (originalPrice: number) => number;
  isLoading: boolean;
}

// Format: COUPON-percentage-slotsLeft  e.g. SELLERKIT26-20-50
const parsePromo = (code: string): { discountPct: number; slotsLeft: number | null } => {
  const parts = code.split("-");
  if (parts.length < 2) return { discountPct: 0, slotsLeft: null };

  const pct = parseInt(parts[parts.length - 2], 10);
  const slots = parseInt(parts[parts.length - 1], 10);

  const discountPct = !isNaN(pct) && pct > 0 && pct < 100 ? pct : 0;
  const slotsLeft = !isNaN(slots) && slots >= 0 ? slots : null;

  return { discountPct, slotsLeft };
};

const useLifetimePromo = (): PromoResult => {
  const { data, isLoading } = useQuery(
    ["site-setting-promo"],
    () => getSiteSettingsByKey({ key: "STRIPE_LIFETIME_PROMO_CODE" }),
    { refetchOnWindowFocus: false, retry: false }
  );

  const promoCode: string | null = data?.[0]?.settingValue ?? null;
  const { discountPct, slotsLeft } = promoCode ? parsePromo(promoCode) : { discountPct: 0, slotsLeft: null };

  const discountedPrice = (originalPrice: number) =>
    discountPct > 0 ? Math.round(originalPrice * (1 - discountPct / 100)) : originalPrice;

  return { promoCode, discountPct, slotsLeft, discountedPrice, isLoading };
};

export default useLifetimePromo;
